import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import carousel from 'vue-owl-carousel'

import VueHorizontal from 'vue-horizontal';
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)


import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)

Vue.config.productionTip = false
Vue.component('OwlCarousel',carousel)
Vue.use(VueHorizontal);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
